import React from 'react';
import { Icon, TIcon } from '@hz-design-system/web-ui';
import NapCarPassLogo from '../../ListingApp/components/Listing/NapCarPassLogo';

import { TListingCarDetail, TListingClient } from 'types/TListing';

import Classes from './CarAttributesMainGroup.module.scss';

type TAttributeProp = {
  item: TListingCarDetail;
  carDetails?: TListingClient['carDetails'];
};

const CarAttributesMainGroup = ({ item, carDetails }: TAttributeProp) => {
  if (!item.value) {
    return null;
  }

  return (
    <div className={`${Classes.itemWithIconWrapper} ${Classes.itemWithIconWrapper}-${item.key}`}>
      <div className={Classes.iconWrapper}>
        <Icon color="text-primary" name={item.icon as TIcon} />
      </div>
      <div className={Classes.itemWithIcon}>
        <div className={Classes.label}>{item.label}</div>
        <div className={Classes.value}>
          {`${item.value} ${item.unit ?? ''}`}
          {item.key === 'mileage' && <NapCarPassLogo carDetails={carDetails} />}
        </div>
      </div>
    </div>
  );
};

export default CarAttributesMainGroup;
